/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../../types/graph';

import * as Operations from './HouseholdInformationMutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type UpdateHouseholdInformationMutationVariables = SchemaTypes.Exact<{
  householdInput: SchemaTypes.HouseholdProfileUpdateMutationInput;
  formInput: SchemaTypes.FormConfirmationsUpdateByCustomerMutationInput;
}>;


export type UpdateHouseholdInformationMutation = { __typename?: 'Mutation', customers: { __typename?: 'CustomersMutation', household_profile_update: { __typename?: 'HouseholdProfile', id: string | null, maritalStatus: string | null, spouseInForceAllInsurers: number | null } | null }, formConfirmationsUpdateByCustomer: { __typename?: 'FormConfirmations', id: string | null } | null };


export function useUpdateHouseholdInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHouseholdInformationMutation, UpdateHouseholdInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHouseholdInformationMutation, UpdateHouseholdInformationMutationVariables>(Operations.UpdateHouseholdInformation, options);
      }
export type UpdateHouseholdInformationMutationHookResult = ReturnType<typeof useUpdateHouseholdInformationMutation>;